export function isTruncated(id: string): boolean {
  const text = document.getElementById(id);
  return text?.offsetWidth && text?.scrollWidth ? text.offsetWidth < text.scrollWidth : false;
}

export function isOptionTruncated(id: string): boolean {
  const text = document.getElementById(id)?.children[0] as HTMLElement;
  if (text) return text?.offsetWidth && text?.scrollWidth ? text.offsetWidth < text.scrollWidth : false;
  return false;
}
